import React from 'react';

const AppPrivacy = () => (
  <div>
    <br /><br />
    <h2>PD Fiber Command IQ Privacy Policy</h2>
    <h4>How PD Fiber, LLC Collects Your Information</h4>
    <p>PD Fiber, LLC collects, and processes information provided directly by you when you install the App and register for an account to use the App. Specifically, this information includes:</p>
    <ul>
      <li>Your name, email address, location, phone number.</li>
      <li>Browser information and session cookies related to your access and use of the App.</li>
      <li>Data insights PD Fiber, LLC attains based on correlation and analytics of your information collected in providing the App, which may be used in aggregated and dis-aggregated formats or to obtain trend analytics, to provide the App; and</li>
      <li>Use of the above-described collected information in aggregated and dis-aggregated formats to enhance our current App or to provide App features.</li>
    </ul>

    <p>How PD Fiber, LLC Uses the Information</p>

    <p>PD Fiber, LLC uses the information collected as described in this Privacy Policy, including personal information, to:</p>
    <ul>
      <li>Provide you with the App as described in the Agreement.</li>
      <li>Implement, improve and/or enhance the App, including to make future releases available to you.</li>
      <li>Carry out obligations as described or authorized in the Agreement and this Privacy Policy.</li>
      <li>Enforce rights arising from the Agreement between you and PD Fiber, LLC; and</li>
      <li>Fulfill any other purpose authorized by you and reasonably required for the App.</li>
    </ul>
    <p><b>For information about deleting your PD Fiber CommandIQ app account and associated data, please contact us via email at support@pdfiber.com or via phone at (573) 559-1615 option 2.</b></p>
  </div>
);

export default AppPrivacy;


// WEBPACK FOOTER //
// ./src/components/sections/documents/app-privacy.js